import { useLayoutEffect, useState } from "react";
import useResponsive from "hooks/useResponsive";
import { placeAnchoredMenu } from "Utils/placeAnchoredMenu";

export const ANCHORED_MENU_BOUNDARY = "[data-anchored-menu-boundary]";

/**
 * Keeps a dropdown inside its modal on every screen size.
 * Pass the trigger ref. The menu style is ready while `open` is true.
 */
export function useAnchoredMenu({
  open,
  anchorRef,
  boundarySelector = ANCHORED_MENU_BOUNDARY,
}) {
  const screenSize = useResponsive();
  const [style, setStyle] = useState(null);

  useLayoutEffect(() => {
    if (!open) {
      setStyle(null);
      return undefined;
    }

    const place = () => {
      const anchor = anchorRef.current;
      if (!anchor) return;
      const boundary = boundarySelector ? anchor.closest(boundarySelector) : null;
      const viewportHeight = window.innerHeight;
      const boundaryRect = boundary
        ? boundary.getBoundingClientRect()
        : {
            top: 0,
            left: 0,
            bottom: viewportHeight,
            width: window.innerWidth,
            height: viewportHeight,
          };
      setStyle(
        placeAnchoredMenu({
          anchorRect: anchor.getBoundingClientRect(),
          boundaryRect,
          viewportHeight,
          screenSize,
        })
      );
    };

    place();
    window.addEventListener("resize", place);
    window.addEventListener("scroll", place, true);
    return () => {
      window.removeEventListener("resize", place);
      window.removeEventListener("scroll", place, true);
    };
  }, [open, screenSize, anchorRef, boundarySelector]);

  return style;
}
